// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAjHpkLUrHueg9hK85dBOSqIRaCwh4bDLY",
  authDomain: "rkindu-8806a.firebaseapp.com",
  projectId: "rkindu-8806a",
  storageBucket: "rkindu-8806a.firebasestorage.app",
  messagingSenderId: "393644235578",
  appId: "1:393644235578:web:c05c0d217f811ab3a9ce03",
  measurementId: "G-JE7B1CC3BP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
